// SPDX-License-Identifier: AGPL-3.0-or-later

import {MessageFlags} from '@fluxer/constants/src/ChannelConstants';

// Discord numbers throughout, so discord.js and discord.py bots work unchanged.
// USER and MESSAGE (context menu) commands are stored and listed for their bot, but not offered to users yet.
export const ApplicationCommandTypes = {
	CHAT_INPUT: 1,
	USER: 2,
	MESSAGE: 3,
} as const;

export const ApplicationCommandOptionTypes = {
	SUB_COMMAND: 1,
	SUB_COMMAND_GROUP: 2,
	STRING: 3,
	INTEGER: 4,
	BOOLEAN: 5,
	USER: 6,
	CHANNEL: 7,
	ROLE: 8,
	MENTIONABLE: 9,
	NUMBER: 10,
	ATTACHMENT: 11,
} as const;

export const InteractionTypes = {
	PING: 1,
	APPLICATION_COMMAND: 2,
	MESSAGE_COMPONENT: 3,
	APPLICATION_COMMAND_AUTOCOMPLETE: 4,
	MODAL_SUBMIT: 5,
} as const;

// PONG answers only an HTTP interactions endpoint, which Micup does not offer.
export const InteractionCallbackTypes = {
	PONG: 1,
	CHANNEL_MESSAGE_WITH_SOURCE: 4,
	DEFERRED_CHANNEL_MESSAGE_WITH_SOURCE: 5,
	DEFERRED_UPDATE_MESSAGE: 6,
	UPDATE_MESSAGE: 7,
	APPLICATION_COMMAND_AUTOCOMPLETE_RESULT: 8,
	MODAL: 9,
} as const;

export const InteractionContextTypes = {
	GUILD: 0,
	BOT_DM: 1,
} as const;

export const InteractionResponseFlags = {
	EPHEMERAL: MessageFlags.EPHEMERAL,
	IS_COMPONENTS_V2: MessageFlags.IS_COMPONENTS_V2,
} as const;

// base64url("interaction:"); a token is base64url("interaction:<id>:" + base64url(32 random bytes)).
export const INTERACTION_TOKEN_PREFIX = 'aW50ZXJhY3Rpb246';

export const MAX_APPLICATION_COMMAND_NAME_LENGTH = 32;
export const MAX_APPLICATION_COMMAND_DESCRIPTION_LENGTH = 100;
export const MAX_APPLICATION_COMMAND_OPTIONS = 25;
export const MAX_APPLICATION_COMMAND_CHOICES = 25;
export const MAX_APPLICATION_COMMANDS_PER_SCOPE = 100;
export const MAX_APPLICATION_COMMAND_CHOICE_NAME_LENGTH = 100;
export const MAX_APPLICATION_COMMAND_CHOICE_STRING_LENGTH = 100;
export const MAX_APPLICATION_COMMAND_STRING_LENGTH = 6000;
export const MAX_APPLICATION_COMMAND_BYTES = 32_768;
export const MAX_APPLICATION_COMMAND_SET_BYTES = 524_288;
export const MAX_APPLICATION_COMMAND_CATALOG_PAGE_SIZE = 50;
export const MAX_APPLICATION_COMMAND_CATALOG_PAGE_BYTES = 131_072;
export const APPLICATION_COMMAND_INDEX_BUCKETS = 64;
export const APPLICATION_COMMAND_CATALOG_BATCH_SIZE = 8;
export const MAX_APPLICATION_COMMAND_CATALOG_CANDIDATES = 50;
export const INTERACTION_ACK_TIMEOUT_MS = 3000;
export const INTERACTION_TOKEN_BYTES = 32;
export const INTERACTION_TTL_SECONDS = 900;
export const INTERACTION_AUTOCOMPLETE_TTL_SECONDS = 10;
export const MAX_INTERACTION_FOLLOWUPS = 20;
export const MAX_INTERACTION_RESPONSE_BYTES = 32_768;
